/* eslint-disable no-unused-vars */
export enum PermissionEnum {
  Cancel = 'Cancel',
  Amend = 'Amend',
  Submit = 'Submit',
  View = 'View',
  test = 'test',
}
